<template>
  <q-page padding>
    <div class="row items-center justify-center q-pt-xl">
      <CarTypes class="card__type--order col-lg-6 col-sm-12" />
    </div>
    <LicencePlate />
  </q-page>
</template>

<script>
import LicencePlate from 'components/Dialogs/Plate';
import CarTypes from 'components/Types';

export default {
  name: 'PageIndex',
  components: {
    CarTypes,
    LicencePlate,
  },
};
</script>
